import React, {Component} from 'react';
import PropTypes from 'prop-types';
const { findDOMNode } = require('react-dom');

import {DragLayer} from 'react-dnd';

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
};

function getItemStyles(props) {
    const { initialClientOffset, initialSourceClientOffset, clientOffset, sourceClientOffset, itemType, dragSourceType } = props;
    if ((dragSourceType && dragSourceType !== itemType) || !sourceClientOffset) {
        return {
            display: 'none'
        };
    }

    const { x, y } = sourceClientOffset;
    //console.log("offset", initialClientOffset, initialSourceClientOffset, clientOffset, sourceClientOffset);
    let transform = 'translate(' + (x) + 'px, ' + (y) + 'px)';

    return {
        transform: transform,
        WebkitTransform: transform
    };
}

function collect(monitor) {
    return {
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialClientOffset: monitor.getInitialClientOffset(),
        initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
        clientOffset: monitor.getClientOffset(),
        sourceClientOffset: monitor.getSourceClientOffset(),

        isDragging: monitor.isDragging()
    };
}

export default DragLayer(collect)(class CustomDragLayer extends Component {
    static propTypes = {
        item: PropTypes.object,
        itemType: PropTypes.string,
        currentOffset: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired
        }),
        isDragging: PropTypes.bool.isRequired,
        dragSourceType: PropTypes.string,
        parent: PropTypes.object
    };

    parentNode = null;

    componentDidMount() {
        this.parentNode = findDOMNode(this.props.parent);
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.props.isDragging === nextProps.isDragging) this.updateOffset();
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.isDragging !== nextProps.isDragging;
    }

    updateOffset = () => {
         if (this.itemContainer) {
            const { transform, WebkitTransform } = getItemStyles(this.props,this.state);
            this.itemContainer.style.transform = transform;
            this.itemContainer.style.WebkitTransform = WebkitTransform;
        }
    };

    renderItem = (type, data) => {
        const { dragSourceType } = this.props;

        if ((!dragSourceType || dragSourceType === type)) {
            //happens when user tries to drop file into reorderable list
            //custom drag layer catches this item too, but it contains no data, so skip it
            if (!data.item) return null;

            const styles = {
                width: this.parentNode.clientWidth
            };

            return (
                <div className="drag-preview" style={styles}>
                    {React.cloneElement(data.item.component, {dndPreview: true})}
                </div>
            );
        } else return null;
    };

    render() {
        const { item, itemType, isDragging } = this.props;
        if (!isDragging) return null;

        return (
            <div style={layerStyles}>
                <div ref={r=>this.itemContainer = r}
                     style={getItemStyles(this.props)}>
                    {this.renderItem(itemType, item)}
                </div>
            </div>
        );
    }
})